import React from 'react';
import { NavLink } from 'react-router-dom';
import { BsHouseFill } from 'react-icons/bs';
import { useBreadcrumbs } from './BreadcrumbContext';

const Breadcrumbs: React.FC = () => {
    const { breadcrumbs } = useBreadcrumbs();

    if (breadcrumbs.length === 0) return null;

    return (
        <nav style={{
            background: 'white',
            padding: '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            marginBottom: '20px',
            border: '1px solid #ddd'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px'
            }}>
                {breadcrumbs.map(({ path, breadcrumb }, index) => (
                    <React.Fragment key={path}>
                        {index > 0 && (
                            <span style={{ color: '#6c757d', margin: '0 4px' }}>/</span>
                        )}
                        <NavLink 
                            to={path} 
                            style={({ isActive }) => ({
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                textDecoration: 'none',
                                color: isActive ? '#007bff' : '#495057',
                                fontWeight: isActive ? '600' : '500',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                transition: 'all 0.2s ease'
                            })}
                        >
                            {path === '/' ? (
                                <BsHouseFill size={16} style={{ color: '#007bff' }} />
                            ) : (
                                breadcrumb
                            )}
                        </NavLink>
                    </React.Fragment>
                ))}
            </div>
        </nav>
    );
};

export default Breadcrumbs;
